module.exports = __webpack_public_path__ + "common/icon-app-novelty-14d0777e8057f2c43033b2451604594f.svg";